import { curveMonotoneX, scaleLinear, scaleLog, line, axisBottom, axisLeft, select } from 'd3';

export default { curveMonotoneX, scaleLinear, scaleLog, line, axisBottom, axisLeft, select };
